module.exports = __webpack_public_path__ + "img/sec_phone6.6b3b2299.png";